export default __webpack_public_path__ + "static/media/CSR_Policy_2.7a90e9b1.pdf";